import React from "react";    
import ZipcodeRangeCampAnyListPageContainer from "./ZipcodeRangeCampAnyListPageContainer";
export class ZipcodeRangeCampAnyListPage extends React.Component {
  render() {
    return <ZipcodeRangeCampAnyListPageContainer {...this.props} />;
  }
}
